/*
 *  File: csa.service.ts
 ********************************************************************
 *  Date        Author                 Changes
 ********************************************************************
 *  02/01/18    Dhanalakshmi Lolugu    Created
 ********************************************************************
 * Copyright (c) 2009 Synapse Group, Inc.
 * 225 High Ridge Park, Stamford, Connecticut, 06905-1325, U.S.A.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of
 * Synapse Group, Inc. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with Synapse Group, Inc.
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import { environment } from '../../environments/environment';

/**
 *
 * @author dlolugu1271
 * @description This is a service class which is used to invoke
 * Salesforce API and create a case for customer service.
 * 
 */
@Injectable()
export class CsaService {

  private appconfig = environment.appconfig;
  public csaResp: any;

  constructor(private http: HttpClient) { }
  
  /**
   *
   * @author dlolugu1271
   * @description This method encodeAsHTML is used to encode the text to html.
   * @augments input
   * 
   */
  encodeAsHTML(input): any {
    return new DOMParser().parseFromString(input, "text/html").documentElement.textContent;
  }

  /**
   *
   * @author dlolugu1271
   * @description This method csaSubmit is used to encode the text to html.
   * @augments reason, firstName, lastName, itemKey, email, message
   * @returns Observable<T>
   * 
   */
  public csaSubmit<T>(reason: string, firstName: string, lastName: string, itemKey:string, email:string, message:string): Observable<T> {
    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    };
    //options.headers.set('X-Requested-With', undefined);
    //options.headers.set('Access-Control-Allow-Origin', "*");
    let body = new URLSearchParams();
    body.set("orgid", environment.appextconfig.csa_submit.csa_org_id);
    body.set("recordType", environment.appextconfig.csa_submit.recordType);
    body.set("reason", reason);
    //body.set("00N37000004nWjC", this.appconfig.custService.csa_submit.application_name);
    body.set("00N37000004oZLR", environment.appextconfig.csa_submit.application);
    body.set("00N37000005WBIq", lastName);
    body.set("00N37000005WBJy", firstName);
    body.set("00N37000005kZXY", itemKey);
    body.set("external", environment.appextconfig.csa_submit.external);
    body.set("email", email);
    body.set("description", this.encodeAsHTML(message));
    return this.http.post<T>(environment.appextconfig.csa_submit.csa_url, body.toString(), options);
  }
  
}



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/services/csa.service.ts